import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend) // Lazy load translations
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    fallbackLng: 'en',
    debug: false,
    
    backend: {
      loadPath: '/locales/{{lng}}.json', // Load only needed language
      requestOptions: {
        cache: 'default', // Use browser cache
      },
    },
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false, // ⚡ PERFORMANCE FIX: Don't block rendering waiting for translations
    },
    
    // ⚡ PERFORMANCE: Load faster by reducing retries
    load: 'languageOnly', // Load 'en' instead of 'en-US'
    
    // Preload the most common language for instant fallback
    preload: ['en'],
  });

export default i18n;

